export const prepareRowContent = (content, leftTariff, rightTariff) => {
  const orderIndex = [...new Set(content.sort((a, b) => Number(a.order) - Number(b.order)).map((item) => item.order))];
  const renderedContent = new Array();

  for (let i = 0; i < orderIndex.length; i++) {
    const order = orderIndex[i];
    const contentWithOrder = content.filter((item) => item.order === order);
    if (contentWithOrder.filter((i) => i.for_tariffs.includes(leftTariff))) {
      const item = contentWithOrder.filter((i) => i.for_tariffs.includes(leftTariff));
      renderedContent.push({
        caption: item[0]?.caption === undefined ? '—' : item[0].caption,
        tooltip_content: item[0]?.tooltip_content,
        tooltip_link: item[0]?.tooltip_link,
        selector: 'left',
        is_bold: item[0]?.is_bold !== undefined ? true : false,
      });
    }
    if (contentWithOrder.filter((i) => i.for_tariffs.includes(rightTariff))) {
      const item = contentWithOrder.filter((i) => i.for_tariffs.includes(rightTariff));

      renderedContent.push({
        caption: item[0]?.caption === undefined ? '—' : item[0].caption,
        tooltip_content: item[0]?.tooltip_content,
        tooltip_link: item[0]?.tooltip_link,
        selector: 'right',
        is_bold: item[0]?.is_bold !== undefined ? true : false,
      });
    }
  }

  if (renderedContent.length === 0) {
    renderedContent.push({
      caption: '—',
      tooltip_content: '',
      tooltip_link: '',
      selector: 'left',
      is_bold: false,
    });
    renderedContent.push({
      caption: '—',
      tooltip_content: '',
      tooltip_link: '',
      selector: 'right',
      is_bold: false,
    });
  }

  return renderedContent;
};
